import { render, staticRenderFns } from "./PostNote.vue?vue&type=template&id=02559667"
import script from "./PostNote.vue?vue&type=script&lang=js"
export * from "./PostNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports